import { render, staticRenderFns } from "./SendDocumentsDrawer.vue?vue&type=template&id=8cd84562&scoped=true"
import script from "./SendDocumentsDrawer.vue?vue&type=script&lang=js"
export * from "./SendDocumentsDrawer.vue?vue&type=script&lang=js"
import style0 from "./SendDocumentsDrawer.vue?vue&type=style&index=0&id=8cd84562&prod&lang=scss&scoped=true"
import style1 from "./SendDocumentsDrawer.vue?vue&type=style&index=1&id=8cd84562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd84562",
  null
  
)

export default component.exports